export default {
  meta: {
    title: '保护期详情',
  },
};
